import { render, staticRenderFns } from "./showCode.vue?vue&type=template&id=2bdb0f50&scoped=true&"
import script from "./showCode.vue?vue&type=script&lang=js&"
export * from "./showCode.vue?vue&type=script&lang=js&"
import style0 from "./showCode.vue?vue&type=style&index=0&id=2bdb0f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdb0f50",
  null
  
)

export default component.exports